import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  BusinessCentralCompany,
  type BusinessCentralCompanyConstructor,
} from './BusinessCentralCompany'

export const BusinessCentralCompanyConstructorFactory =
  Factory.Sync.makeFactory<BusinessCentralCompanyConstructor>({
    remoteId: Factory.each(() => faker.random.uuid()),
    mergeId: Factory.each(() => faker.random.uuid()),
    name: Factory.each(() => faker.company.companyName()),
  })

export const BusinessCentralCompanyFactory = EntityFactory(
  BusinessCentralCompany,
  BusinessCentralCompanyConstructorFactory
)
